var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3677 12.5195C13.3677 13.4152 12.6385 14.1432 11.7427 14.1432H3.48091C2.58577 14.1432 1.85715 13.4152 1.85715 12.5195V4.25765C1.85715 3.36189 2.58577 2.63327 3.48091 2.63327H5.10963C5.62247 2.63327 6.0382 2.21753 6.0382 1.7047C6.0382 1.19186 5.62247 0.776123 5.10963 0.776123H3.48091C1.56124 0.776123 0 2.33736 0 4.25765V12.5195C0 14.4398 1.56124 16.0004 3.48091 16.0004H11.7427C13.663 16.0004 15.2249 14.4398 15.2249 12.5195V10.8895C15.2249 10.3767 14.8092 9.96095 14.2963 9.96095C13.7835 9.96095 13.3677 10.3767 13.3677 10.8895V12.5195Z",
    fill: "#3C7AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7298 2.57308L13.4288 0.272072C13.0661 -0.0906907 12.4786 -0.0906907 12.1158 0.272072L5.79534 6.59442C5.67773 6.71142 5.59353 6.85875 5.55206 7.0197L4.7541 10.1187C4.67177 10.4369 4.76463 10.7749 4.99739 11.007C5.1732 11.1834 5.41092 11.2788 5.6542 11.2788C5.73096 11.2788 5.80896 11.2689 5.88511 11.249L8.98407 10.4511C9.14502 10.4102 9.29173 10.326 9.40935 10.2078L15.7298 3.88608C15.9038 3.71213 16.0016 3.47627 16.0016 3.22927C16.0016 2.98227 15.9044 2.74765 15.7298 2.57308ZM8.27464 8.71528L6.94492 9.05761L7.28725 7.7279L12.7726 2.2425L13.7606 3.23051L8.27464 8.71528Z",
    fill: "#3C7AF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.b55f90b6508319c7cb38a38233a35f8f.svg";
export { ForwardRef as ReactComponent };